// CORP-8479: cache curto em localStorage para dados que o app refazia a cada F5 (sessão do usuário,
// painéis do Looker que decidem o menu do Labs, opções dos filtros…). O valor só vale dentro do
// prazo; fora dele, ou sem armazenamento, o chamador busca de novo como antes. Sempre por chave
// que inclui o `holdingId`, para nada vazar entre holdings.
//
// O miolo é o `@front-persist-state/core`; este arquivo só mantém os nomes que o app já usa.
import {
  cached,
  get,
  remove,
  removeByPrefix,
  set,
} from '@front-persist-state/core';

const NAMESPACE = 'fresh:';

export const FRESH_TTL_MS = 10 * 60 * 1000;

export function readFresh<T>(key: string, ttlMs: number = FRESH_TTL_MS): T | null {
  return get<T>(NAMESPACE + key, ttlMs, 'local') ?? null;
}

export function writeFresh<T>(key: string, value: T): void {
  set(NAMESPACE + key, value, 'local');
}

export function clearFresh(key: string): void {
  remove(NAMESPACE + key, 'local');
}

// Remove todas as entradas cujo nome começa com `prefix` (ex.: invalidar tudo de uma holding depois
// de uma escrita).
export function clearFreshPrefix(prefix: string): void {
  removeByPrefix(NAMESPACE + prefix, 'local');
}

// Cache + deduplicação de requisição. Chamadas simultâneas com a mesma chave compartilham UMA
// requisição, e só resposta bem-sucedida é guardada — erro nunca fica salvo.
export function cachedRequest<T>(
  key: string,
  load: () => Promise<T>,
  ttlMs: number = FRESH_TTL_MS,
): Promise<T> {
  return cached({ key: NAMESPACE + key, ttlMs, load, storage: 'local' });
}
